<template>
    <b-card title="Notification Types" class="mb-2">
        <!-- table -->
        <vue-good-table
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table striped condensed no-outline"
        >
            <template
                slot="table-row"
                slot-scope="props"
            >
                <!-- Column: type -->
                <span
                    v-if="props.column.field === 'type'"
                    class="text-nowrap"
                >
                    <span class="text-nowrap">{{ props.row.type }}</span>
                </span>
        
                <!-- Column: enabled -->
                <span v-else-if="props.column.field === 'enabled'">
                    <span v-if="props.row.enabled == true" @click="toggleType(props.row)" style="cursor: pointer;"><b-badge pill variant="light-success">Yes</b-badge></span>
                    <span v-else @click="toggleType(props.row)" style="cursor: pointer;"> <b-badge pill variant="light-danger">No</b-badge></span>
                </span>

                <!-- Column: Status -->
                <span v-else-if="props.column.field === 'index'">
                    <span>{{props.row.originalIndex+1}}</span>
                </span>
        
                <!-- Column: Common -->
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </b-card>
</template>
  
<script>
import {
    BAvatar,
    BButton,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BModal,
    VBModal,
    BCardText,
    BFormFile
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import vSelect from "vue-select"
import Ripple from "vue-ripple-directive";
import {mapState} from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
  
export default {
    components: {
        VueGoodTable,
        BAvatar,
        BCard,
        BBadge,
        BButton,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BModal,
        BCardText,
        BFormFile,
        vSelect
    },

    directives: {
        'b-modal': VBModal,
        Ripple,
    },

    computed: {
        ...mapState('settings', ["categories","categoriesError","categoriesLoading", "submitError","submitSuccess","submitLoading"]),
    
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },

    watch: {
        categories(newValue, oldValue) {
            if (newValue) {
                this.rows = this.categories
            }
        }
    },

    data() {
        return {
            host: "https://api-biyeruti.smicee.com",
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: '#',
                    field: 'index',
                    type:'number',
                    tdClass: 'text-center',
                    thClass:'text-center',
                    sortable: false
                },
                {
                    label: 'Type',
                    field: 'type',
                    tdClass: 'text-center',
                    thClass:'text-center',
                    sortable: false
                },
                {
                    label: 'Enabled',
                    field: 'enabled',
                    tdClass: 'text-center',
                    thClass:'text-center',
                    sortable: false
                },
            ],
            delete_id: null,
            rows: [],
            type: {
                notification_type: '',
                is_enabled: false
            }
        }
    },

    created() {
        this.$store.dispatch('settings/fetchNotificationCategories')
        this.rows = this.categories
        let permissions=JSON.parse(localStorage.getItem('permissions'))
    },

    methods: {
        async toggleType(data) {
            this.type.notification_type = data.type
            if(data.enabled == true) {
                this.type.is_enabled = false
            } else {
                this.type.is_enabled = true
            }

            await this.$store.dispatch("settings/toggleNotificationCategory", this.type).then(result=>{
                if(result.code == 200) {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Success`,
                            icon: 'ThumbsUpIcon',
                            variant: 'success',
                            text: result.message
                        }
                    })
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `Error`,
                            icon: 'ThumbsDownIcon',
                            variant: 'error',
                            text: result.message
                        }
                    })
                }
            })
        }
    } 
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

@import '@core/scss/vue/libs/vue-good-table.scss';
</style>